import {useEffect} from 'react';
import {usePreCruiseContext} from "../context/PreCruiseContext";
import {getFromHub} from "../actions/networkActions";

const usePreCruisePassenger = (passengerId) => {
    const {preCruiseInfo, setPreCruiseInfo} = usePreCruiseContext();

    useEffect(() => {
        if(preCruiseInfo?.passengers) {
            return;
        }

        let isCancelled = false;

        const fetchData = async () => {
            const url = "passengers/all";
            const response = await getFromHub(url);

            if(!isCancelled) {
                setPreCruiseInfo({passengers: response.map(passenger => ({...passenger, passengerId: passenger.id}))});
            }
        }

        fetchData();

        return () => {
            isCancelled = true;
        };

    }, [passengerId]);

    return preCruiseInfo?.passengers?.find(pax => pax.passengerId === passengerId) || {};
}

export default usePreCruisePassenger;